<template>
  <el-dialog
    :title="type_name + ' пользователей'"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
    width="70%"
  >
    <div style="margin-bottom: 32px;">
      <div class="filters-before-table" style="margin-top: 5px">
        <search-input
          placeholder="Поиск по ФИО"
          style="width: 300px"
          v-model="search"
          @change="loadAxisUserValues"
        >
        </search-input>
      </div>
      <el-table :data="axis_user_values" v-loading="loading">
        <el-table-column width="150" prop="user.persnum" label="Перс. №"></el-table-column>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column width="90" label="Значение">
          <template v-slot="scope">
            {{ scope.row.value }}
            <el-tooltip v-if="scope.row.card_id" content="Перейти в карту" placement="top">
              <router-link
                class="table-router-link"
                :to="{ name: 'Card', params: { id: scope.row.card_id } }"
                target="_blank"
              >
                <el-button
                  class="table-action-button"
                  round
                  size="mini"
                  icon="fas fa-external-link-alt"
                >
                </el-button>
              </router-link>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column width="50" align="center">
          <template v-slot="scope">
            <el-popconfirm
              confirm-button-text='Да'
              cancel-button-text='Нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите удалить данные пользователя?"
              @confirm="deleteAxisUserValue(scope.row)"
            >
              <el-button
                slot="reference"
                class="table-action-button"
                size="mini"
                round
                icon="far fa-trash-alt"
              >
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <paginator
        :paginator.sync="paginator"
        use-router-query-param
        @page-changed="loadAxisUserValues"
      ></paginator>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="show = false">Закрыть</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";

export default {
  name: "talent-matrix-axis-user-values-dialog",
  components: {
    SearchInput,
    Paginator,
  },
  data() {
    return {
      search: '',
      type: '',
      type_name: '',
      show: false,
      loading: false,
      axis_user_values: [],
    }
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  mixins: [paginator],
  methods: {
    async open(type) {
      this.paginator.page = 1;
      this.type = type;
      this.axis_user_values = [];
      this.search = '';
      this.type_name = type === 'potential' ? 'Потенциал' : 'Производительность';
      this.loadAxisUserValues();
      this.show = true;
    },
    close() {
      this.show = false;
    },
    loadAxisUserValues() {
      this.loading = true;
      this.$api.talentMatrix.matrixAxisUserValuesSearch({
        expand: ['user'].join(),
        type: this.type,
        search: this.search,
        matrix_id: this.$route.params.id,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.axis_user_values = data.axis_user_values;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteAxisUserValue(axisValueUser) {
      this.loading = true;
      this.$api.talentMatrix.matrixAxisUserValuesDelete({
        ids: [axisValueUser.id],
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Данные пользователя успешно удалены'
          });
        })
        .finally(() => {
          this.loadAxisUserValues();
          this.$emit('update-matrix');
        })
    },
  }
}
</script>

<style>
</style>